module.exports = __webpack_public_path__ + "static/media/after.d6c315c2.gif";